import { ApexApiError } from 'apex-ui-services'
import { AxiosResponse } from 'axios'
import { Dispatch } from 'redux'
import { createGenericError } from 'utils'
import { getInterestedParties as getInterestedPartiesApi } from '../api'
import { HttpResponseStatusCodes } from '../constants'

export const GET_INTERESTED_PARTIES = 'GET_INTERESTED_PARTIES'
export const GET_INTERESTED_PARTIES_SUCCESS = 'GET_INTERESTED_PARTIES_SUCCESS'
export const GET_INTERESTED_PARTIES_FAILURE = 'GET_INTERESTED_PARTIES_FAILURE'

export const getInterestedParties = (
  accountNumber: string,
  dispatch: Dispatch,
  onError: (error: string) => void
) => {
  dispatch({ type: GET_INTERESTED_PARTIES, accountNumber })
  getInterestedPartiesApi(accountNumber)
    .then((response: AxiosResponse) => {
      const { data } = response
      dispatch({
        type: GET_INTERESTED_PARTIES_SUCCESS,
        interestedParties: data,
      })
    })
    .catch((error: ApexApiError) => {
      const httpResponseStatus = error.response?.status
      if (httpResponseStatus === HttpResponseStatusCodes.NotFound) {
        dispatch({
          type: GET_INTERESTED_PARTIES_SUCCESS,
          interestedParties: undefined,
        })
      } else {
        createGenericError(
          error,
          dispatch,
          GET_INTERESTED_PARTIES_FAILURE,
          onError
        )
      }
    })
}
